import { Component, inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { PreAssessmentHistoryItem } from '../../assesment-const/assessment-details-models';
import { Router } from '@angular/router';
import { CalendarModule } from 'primeng/calendar';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'patient-assessment-history-list',
  standalone: true,
  imports: [CommonModule, DialogModule, CalendarModule, FormsModule],
  templateUrl: './assessment-history-list.component.html',
  styleUrl: './assessment-history-list.component.css'
})
export class AssessmentHistoryListComponent implements OnChanges {
  @Input() history: PreAssessmentHistoryItem[] = [];
  @Input() assessmentDetails: any; // You can replace 'any' with the actual type of detailsData if available

  private router = inject(Router);

  displayModal: boolean = false;
  selectedAssessment: PreAssessmentHistoryItem | null = null;
  previousScore: number = 0;

  // Date Filter State
  dateRange: (Date | null)[] | null = null;
  filteredHistory: PreAssessmentHistoryItem[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['history']) {
      this.applyDateFilter();
    }
  }

  applyDateFilter() {
    if (!this.dateRange || !this.dateRange[0]) {
      this.filteredHistory = [...this.history];
      return;
    }

    const start = new Date(this.dateRange[0]);
    start.setHours(0, 0, 0, 0);

    let end = new Date(this.dateRange[0]);
    if (this.dateRange[1]) {
      end = new Date(this.dateRange[1]);
    }
    end.setHours(23, 59, 59, 999);

    this.filteredHistory = this.history.filter((item) => {
      if (!item.date) return true;
      const parts = item.date.split('-');
      if (parts.length !== 3) return true;
      const itemDate = new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]));
      itemDate.setHours(0, 0, 0, 0);
      return itemDate.getTime() >= start.getTime() && itemDate.getTime() <= end.getTime();
    });
  }

  openDetails(item: PreAssessmentHistoryItem) {
    this.selectedAssessment = item;
    // Calculate the previous score conceptually
    if (item.is_positive) {
      this.previousScore = item.value - item.progress_from_last_assessment;
    } else {
      this.previousScore = item.value + item.progress_from_last_assessment;
    }

    // Safety check just in case calculations go below 0 or above 100 on corrupt data
    this.previousScore = Math.max(0, Math.min(100, this.previousScore));

    this.displayModal = true;
  }

  getLabel(score: number): string {
    if (score >= 70) return 'Good Health';
    if (score >= 40) return 'Average Health';
    return 'Needs Work';
  }

  getHintText(item: PreAssessmentHistoryItem): string {
    if (item.progress_from_last_assessment === 0) {
      return "Your score has remained consistent compared to previous inputs.";
    }
    if (item.is_positive) {
      return "Nutrition habits improved, continuing physical activity routines can boost your score further!";
    }
    return "Moderate health score with room for improvement in activity levels or hydration.";
  }

  getModalAlertText(item: PreAssessmentHistoryItem): string {
    if (item.progress_from_last_assessment === 0) {
        return "Your health score has remained unchanged since your last assessment. Consider slight routine improvements to gain momentum.";
    }
    if (item.is_positive) {
        return "Your health score has improved compared to the previous assessment! Keep up the good nutrition, hydration, and activity routines.";
    }
    return "Your health score has decreased compared to the previous assessment. Improving nutrition, hydration, sleep, and activity can help boost your score.";
  }


  goToAssessmentScore(){
    this.router.navigateByUrl('/create-score', { state: { assessmentDetails: this.assessmentDetails } });
  }
}
